import { PayFlowTransactionTypeEnum } from '../app/core/enums/payflow/payflow-transaction-type.enum';
import { SingleCabinFormCapacityType } from '../app/core/enums/single-cabin-form-capacity-type.enum';
import { PayflowRequestVerbosityEnum } from '../app/core/enums/payflow/payflow-request-verbosity.enum';
import { PaypalMode } from '../app/core/enums/paypal/paypal-mode.enum';
import { PaypalRequestIntent } from '../app/core/enums/payflow/paypal-request-intent.enum';
import { NumberTypeEnum } from '../app/core/enums/payflow/number-type.enum';
export const environment = {
  production: true,
  console_log: false,
  enable_login: true,
  geoIpServiceUrl: 'https://geoip.maxmind.com/geoip/v2.1/city/me',
  pathUrlOrigin: 'https://availability.galavail.com/',
  app_resources: {
    images: { path: 'assets/images/' },
    icons: { path: 'assets/images/icons/' },
    fleet_photo_directory: {
      server: 'https://galavail.com',
      path: 'upload/fleet',
    },
    cruise_photo_directory: {
      server: 'https://galavail.com',
      path: 'upload/cruises',
    },
    cabin_photo_directory: {
      server: 'https://galavail.com',
      path: 'upload/cabinas',
    },
    itinerary_photo_directory: {
      server: 'https://galavail.com',
      path: 'upload/itinerario',
    },
    fake_cruise_default_photo: { path: 'assets/images/icons/loading_icon.gif' },
  },
  GI_ECOM_CONTACT_FORM:
    'https://services.galavail.com/gi-web/webresources/glcforms/ecom/',
  GI_ECOM_CONTACT_FORM_CRM:
    'https://services.galavail.com/gi-web/webresources/glcforms/ecomForm/',
  restCountriesServer: 'https://restcountries.eu/rest/v2/all',
  single_cabin_form_capacity: {
    type: SingleCabinFormCapacityType.FIXED,
    capacity: 2,
  },
  firebase: {
    apiKey: 'AIzaSyAGqNllLBVRBFGVUzB3H-7-xTHKq26XPls',
    authDomain: 'e-commerce-desarrollo.firebaseapp.com',
    databaseURL: 'https://e-commerce-desarrollo.firebaseio.com',
    projectId: 'e-commerce-desarrollo',
    storageBucket: 'e-commerce-desarrollo.appspot.com',
    messagingSenderId: '119233533832',
  },
  ngGtcPayflow: {
    apiUrl: 'https://cloud.galavail.com/webservice/agencyServices/payflowNew/',
    numberType: NumberTypeEnum.EVEN,
    defaultVerbosity: PayflowRequestVerbosityEnum.high,
    defaultTransactionType: PayFlowTransactionTypeEnum.sale,
    clientTimeOutForRequestingTransactions: 45,
  },
  ngGtcPayflowonHold: {
    apiUrl: 'https://cloud.galavail.com/webservice/agencyServices/payflowNew/',
    numberType: NumberTypeEnum.EVEN,
    defaultVerbosity: PayflowRequestVerbosityEnum.high,
    defaultTransactionType: PayFlowTransactionTypeEnum.sale,
    clientTimeOutForRequestingTransactions: 45,
  },
  firebase_table_names: {
    genders: 'genders',
    countries: 'countries',
    purchase_requests: 'purchase_requests',
    itineraries_periods: 'itineraries_periods',
    ip_white_list: 'ipwhitelist',
  },
  BOOKING_CONFIRMATION_SERVICE:
    'https://cloud.galavail.com/webservice/ecommerceWSAPI/sendConfirmationMail',
  PAYPAL_EXPRESS_CHECKOUT_CONFIG: {
    API_MODE: PaypalMode.PRODUCTION,
    REQUEST_INTENT: PaypalRequestIntent.CAPTURE,
    CLIENT_SANDBOX_TOKEN:
      'AXRHmFARCmMmKqcCM1r8fIWaF7N7wXVdYWwuCHVQDqz6zstE0BsgC4znWV2RGqdF86YlMFYjWhwBLMPG',
    CLIENT_PRODUCTION_TOKEN:
      'AWZZ9jjpr8ch5S-Q4UVj35MoMrMuLTUtaE4LBgr-rXDVo24kiQ94wQNJOZbyOXNrf2ECZmIyg4RWWVcl',
    CURRENCY: 'USD',
  },
  PURCHASE: {
    MIN_TIME_TO_ENABLE_AUTOPAYMENT: 72,
    IS_AUTO_PAYMENT_ACCEPTED: true,
    search_expiration_time: 1000,
  },
  pathEcommerceGalavail: 'https://ecommerce.galavail.com',
  itineraryPathImg: 'https://galavail.com/upload/itinerario/',
  fleetPathImg: 'https://galavail.com/upload/fleet/',
  fleetPathImgCard: 'https://galavail.com/upload/fleet/card/',
  companyLogosImg: 'https://galavail.com/upload/company/logos/',
  cabinPathImg: 'https://galavail.com/upload/cabinas/',
  cruisePhotosPathImg: 'https://galavail.com/upload/cruises/',
  itineraryPhotoDirectory: 'https://galavail.com/upload/itinerario/',
  deckplans: 'https://galavail.com/upload/deckplans',
  visitorPoint: 'https://galavail.com/upload/visitas/',
  pathService: 'https://cloud.galavail.com/webservice/agencyServices',
  pathServiceAv: 'https://cloud.galavail.com/webservice/agencyServices',
  ngGtcPayStripe: {
    apiUrl: 'https://cloud.galavail.com/webservice/agencyServices/paystripe/',
    numberType: NumberTypeEnum.EVEN,
    defaultVerbosity: PayflowRequestVerbosityEnum.high,
    defaultTransactionType: PayFlowTransactionTypeEnum.sale,
    clientTimeOutForRequestingTransactions: 45,
  },
  ngGtcPaySquare: {
    apiSquare: 'https://web.squarecdn.com/v1/square.js',
    apiUrl: "https://cloud.galavail.com/webservice/agencyServices/paysquare/",
    numberType: NumberTypeEnum.EVEN,
  },
  pathAgencyEcommerceAPI: {
    findLastMinute: 'https://cloud.galavail.com/webservice/agencyEcommerceAPI/findLastMinute',
  },
  pathAuth0Token: 'https://cloud.galavail.com/api/v1/tokens/auth0',
  pathUuid: 'https://cloud.galavail.com/api/v1/tokens/uuid',
  pathLoginToken: 'https://auth.galavail.com/api/v1/auth/login',
  pathAuditClientAccess: 'https://cloud.galavail.com/api/v1/audit/clients/access',
  access_method: 'WEB',
  geioip: {
    apiUrl: 'https://services.galavail.com/gi-web/webresources/location/geoip/',
    numberType: NumberTypeEnum.EVEN
  },
  max_available: 6,
  max_only_available: 2,
  pathWetravelService: 'https://dev.cloud.galavail.com/wetravel/payment/link',
  wetravel: {
        cdnScript: 'https://demo.cdn.wetravel.com/widgets/embed_checkout.js',
        envUrl: 'https://demo.wetravel.to',
        checkoutBaseUrl: 'https://demo.wetravel.to/checkout_embed',
        widgetVersion: 'v0.3'
  }
};
